import React from 'react';

import ResponseSettingsForm from '../../../../modules/business-profile/components/ResponseSettingsForm';

export default function ResponseSettingsTab() {
  return <ResponseSettingsForm />;
}
